export const FETCH_GLOBAL_DATA_SUCCESS = 'FETCH_GLOBAL_DATA_SUCCESS';
export const FETCH_GLOBAL_DATA_FAILURE = 'FETCH_GLOBAL_DATA_FAILURE';
export const UPDATE_PROJECT_TOTAL_COST = 'UPDATE_PROJECT_TOTAL_COST';